const TokenName = Object.freeze({
    ROOT: 'ROOT',
    SPACE: 'SPACE',
    LINE_FEED: 'LF',
    PIPE: 'PIPE',
    OPEN_SPECIAL: 'OPEN_SPECIAL',
    CLOSE_SPECIAL: 'CLOSE_SPECIAL',
    COLOR_RED: 'COLOR_RED',
    COLOR_BLUE: 'COLOR_BLUE',
    COLOR_GREEN: 'COLOR_GREEN',
    TITLE_1: 'TITLE_1',
    TITLE_2: 'TITLE_2',
    TITLE_3: 'TITLE_3',
    EMPHASIS: 'EMPHASIS',
    HIDDEN_INPUT: 'HIDDEN_INPUT',
    TABLE: 'TABLE',
    TABLE_HEADER: 'TABLE_HEADER',
    WRITING_PRACTICE: 'WRITING_PRACTICE',
    CHARACTER_LITERAL: 'CHARACTER_LITERAL',
    AUDIO: 'AUDIO',
});

export {TokenName}